<template>
	<div class="global-footer-logo">
		<a
			href="https://www.webmd.com/"
			v-metric="{ link: 'logo' }"
		>
			<img
				src="https://img.wbmdstatic.com/vim/live/webmd/consumer_assets/site_images/oncology/1/images/webmd-logo-white.svg"
				alt="Logo for WebMD"
				title="WebMD: Better information. Better health."
				height="26"
				width="110"
				loading="lazy"
			/>
		</a>
	</div>
</template>
<script>
export default {
	name: 'FooterLogo',
};
</script>
